import React from "react";
import axios from "axios";
import { BASE_URL, ROLES, ADMIN, HEADERS, REGISTER } from "../../common/api";
import { EditButton, DeleteButton, AddButton } from "../../assets/js/Button";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import Error from "../../assets/js/Error";


export default class Admin extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            show: false,
            confirm: false,
            id: "",
            admins: [],
            status: 0,
            username: "",
            first_name: "",
            last_name: "",
            password: "",
            role: "",
            phone: "",
            receive_message: false,
            roles: [],
            showAlert: true,
        }
        this._isMounted = false;
        this.timer = null;
    }

    showModal = () => {
        this.setState({ show: true });
    }


    showConfirmationModal = (id) => {
      this.setState({confirm: true, id: id})
    }

    hideModal = () => {
        this.setState({ show: false, confirm: false });
    }



    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    getTitle = () => {
        const {id} = this.state;
        if (id) {
            return <h3>Изменить</h3>;
            } else {
            return <h3>Добавить новый</h3>;}
    }

    get = (item) => {

        this.setState({
            id: item.id,
            username: item.username,
            first_name: item.first_name,
            last_name: item.last_name,
            password: item.password,
            role: item.role,
            role_name: item.role_name,
            phone: item.phone,
            receive_message: item.receive_message,
            show: true,
        });
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
          this.setState({ showAlert: false });
          }, 3000);
        const arr = [];
        this._isMounted = true;
        axios.get(BASE_URL + ADMIN, HEADERS).then((res) => {
            this._isMounted && this.setState({ admins: res.data, status: res.status });
        }).catch((err)=> {
        this._isMounted && this.setState({status: err.response.status})
      })
      
      this._isMounted &&
      axios.get(BASE_URL + ROLES + 'list/', HEADERS).then((res) => {
        let result = res.data;
        result.map((item) => {
            return arr.push({value: item.id, label: item.title});});
        this._isMounted && this.setState({ roles: res.data, status: res.status});
      }
      ).catch((err)=> {
        this._isMounted && this.setState({status: err.response.status})
      })
    }

    componentDidUpdate(prevProps, prevState) {
      if(prevState.show && !this.state.show) {
        this.setState({
          id: "",
          username: "",
          first_name: "",
          last_name: "",
          password: "",
          role: "",
          phone: "",
          receive_message: false,
          showAlert: false,
        })
      }
    }

    componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timer);
    }

    delete = (id, event) => {
        event.preventDefault();
        const {admins} = this.state;
        axios.delete(BASE_URL + ADMIN + id + '/', HEADERS).then((res) => {
            this.setState({ admins: admins.filter((item) => item.id !== id), confirm: false, id: "" });
        });}

    addOrUpdate = (event) => {
        event.preventDefault();
        const {id, admins, username, password, first_name, last_name, role, phone, receive_message} = this.state;
        let data = {
            username: username,
            password: password,
            first_name: first_name,
            last_name: last_name,
            role: role,
            phone: phone,
            receive_message: receive_message,
        }

        if (id) {
            axios.put(BASE_URL + ADMIN + id + '/', data, HEADERS).then((res) => {
                const {admins} = this.state;
                const index = admins.findIndex((item) => item.id === id);
                admins[index] = res.data;
                this.setState({ admins: admins, show: false });
                })
                .catch((error) => {
                    this.setState({ error: error.response.status });
        })
    }
        else {
            axios.post(BASE_URL + REGISTER, data, HEADERS).then((res) => {
                this.setState({ admins: [...admins, res.data], show: false });
            }
        ).catch((error) => {
          this.setState({ error: error.response.status });
        })}
    }


    render() {
        const {admins, show, username, first_name, last_name, password, id, role, roles, confirm, receive_message, phone, showAlert, status} = this.state;
        const {location} = this.props;
        const message = location.state?.message;
        return (
            <>
            {(message && showAlert) && <div className="alert-div"><Alert variant="success" key="success" onClose={() => this.setState({ showAlert: false })}>{message}</Alert></div>}
            {status === 200 ? (<>
            <Modal
              show={show}
              onHide={() => {
                this.hideModal();
              }}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>{this.getTitle()}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={(event) => this.addOrUpdate(event)}>
                  <Form.Group
                    className="mb-3"
                    
                  >
                    <Form.Label>Username:</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={username}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Имя:</Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={first_name}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Фамилия:</Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={last_name}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Номер телефона:</Form.Label>
                    <Form.Control
                      type="phone"
                      name="phone"
                      value={phone}
                      onChange={this.handleChange}
                    />
                    <Form.Label>Отправить СМС:</Form.Label>
                    <Form.Control
                      as="select"
                      onChange={this.handleChange}
                      name="receive_message"
                      value={receive_message}
                    >
                      <option value="true">Да</option>
                      <option value="false">Нет</option>
                    </Form.Control>
                    <Form.Label>Пароль:</Form.Label>
                    {id ? (
                        <>
                        <Button variant="primary" type="button" className="m-3">
                          <Link to={{pathname: 'password-change/', state: id}}>Изменить пароль</Link>
                        </Button>
                        <br />
                        </>
                    ) : 
                    (
                        <Form.Control
                      type="password"
                      name="password"
                      id="password"
                      value={password}
                      onChange={this.handleChange}
                    />
                    )
                    }

                    <Form.Label>Роль:</Form.Label>
                  <Form.Control as="select" onChange={this.handleChange}
                  name="role" value={role} >

                    <option hidden>Выберите роль</option>
                    {roles.map((role)=> (
                      <option value={role.id} key={role.id}>{role.title}</option>
                    ))}
                  </Form.Control>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={this.showModal}
                  >
                    Сохранить
                  </Button>
                </Form>
              </Modal.Body>
            </Modal>
            
            <div>
              <AddButton onClick={this.showModal} />
              <hr />
            </div>


            <table className="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Ф.И.О</th>
                            <th>Роль</th>
                            <th>Номер телефона</th>
                            <th>Отправить СМС</th>
                            <th>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {admins.map(item =>
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.first_name + " " + item.last_name}</td>
                                <td>{item.role_name}</td>
                                <td>{item.phone}</td>
                                <td><p className={item.receive_message ? "badge badge-light text-success" : "badge badge-light text-danger"}>{item.receive_message ? "Да" : "Нет"}</p></td>                
                              <td>
                                <EditButton onClick={() => this.get(item)} />
                                <DeleteButton onClick={()=>this.showConfirmationModal(item.id)} />

                              </td>

                            </tr>
                            )}
                    </tbody>
                </table>


                {/* Delete confirmation modal field */}
          <Modal
            show={confirm}
            onHide={() => {
                this.hideModal();
              }}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>Удалить</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5>Вы уверены, что хотите удалить эту информацию?</h5>
                <button className="btn btn-danger m-1" onClick={(event) => this.delete(id, event)} >Удалить</button>
                <button className="btn btn-light outline-secondary" onClick={() => {
                this.hideModal();
              }} >Назад</button>
              </Modal.Body>
            </Modal>
            </>) : (<Error status={status} />)}
            </>
        )
    }
}